module.exports = __webpack_public_path__ + "media/images/product/f_k-23d953abbbc7282e71c3a90e609df035.png";